import * as Page from '@/enums/page-name.enum'

export const provide = () => {
  return {
    Page
  }
}
